import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import HomePage from "@/pages/HomePage";
import ProductsPage from "@/pages/ProductsPage";
import MushinControlPage from "@/pages/MushinControlPage";
import MushinNexusPage from "@/pages/MushinNexusPage";
import MushinConnectPage from "@/pages/MushinConnectPage";
import SolutionPage from "@/pages/SolutionPage";
import ClientsPage from "@/pages/ClientsPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import PackagesPage from "@/pages/PackagesPage";
import SecurityPage from "@/pages/SecurityPage";
import Manufacturing4Page from "@/pages/Manufacturing4Page";
import PlatformsPage from "@/pages/PlatformsPage";
import AutomotivePage from "@/pages/industries/AutomotivePage";
import AerospacePage from "@/pages/industries/AerospacePage";
import PharmaceuticalsPage from "@/pages/industries/PharmaceuticalsPage";
import FMCGPage from "@/pages/industries/FMCGPage";
import ExportManufacturingPage from "@/pages/industries/ExportManufacturingPage";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="min-h-screen bg-[#060606] text-white">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/products/control" element={<MushinControlPage />} />
            <Route path="/products/factory-os" element={<MushinControlPage />} />
            <Route path="/products/nexus" element={<MushinNexusPage />} />
            <Route path="/products/connect" element={<MushinConnectPage />} />
            <Route path="/products/vendor-connect" element={<MushinConnectPage />} />
            <Route path="/solutions/:slug" element={<SolutionPage />} />
            <Route path="/clients" element={<ClientsPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/packages" element={<PackagesPage />} />
            <Route path="/security" element={<SecurityPage />} />
            <Route path="/manufacturing-4" element={<Manufacturing4Page />} />
            <Route path="/platforms" element={<PlatformsPage />} />
            <Route path="/industries/automotive" element={<AutomotivePage />} />
            <Route path="/industries/aerospace" element={<AerospacePage />} />
            <Route path="/industries/pharmaceuticals" element={<PharmaceuticalsPage />} />
            <Route path="/industries/fmcg" element={<FMCGPage />} />
            <Route path="/industries/export-manufacturing" element={<ExportManufacturingPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
